import { Spin } from 'antd';

const TcMapLoading = () => {
  return (
    <div className='absolute top-0 left-0 z-50 w-full h-full overflow-hidden shadow-md backdrop-filter backdrop-blur-sm'>
      <div className='relative flex items-center justify-center w-full h-full'>
        <div className='absolute z-10 flex px-3 py-1 -translate-x-1/2 bg-t-bg-color shadow-md top-2 left-1/2 gap-x-2'>در حال اعمال تغییرات</div>
        <Spin />
      </div>
    </div>
  );
};

export default TcMapLoading;
